"use client";

import { useState, useEffect } from "react";

type ViewMode = "grid" | "list";

const STORAGE_KEY = "afs-media-view-mode";

export function useMediaViewMode(defaultMode: ViewMode = "grid") {
  const [viewMode, setViewModeState] = useState<ViewMode>(defaultMode);

  // Load saved preference from localStorage on mount
  useEffect(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved && (saved === "grid" || saved === "list")) {
        setViewModeState(saved as ViewMode);
      }
    } catch (error) {
      console.warn("Failed to load media view mode from localStorage:", error);
    }
  }, []);

  // Function to update view mode and save to localStorage
  const setViewMode = (mode: ViewMode) => {
    try {
      setViewModeState(mode);
      localStorage.setItem(STORAGE_KEY, mode);
    } catch (error) {
      console.warn("Failed to save media view mode to localStorage:", error);
      // Still update state even if localStorage fails
      setViewModeState(mode);
    }
  };

  return [viewMode, setViewMode] as const;
}
